import {
	WeaLocaleProvider
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default class AbsenceBrief extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			absenceDay
		} = this.props;

		return (
			<div className='brief'>
				<div className='value'>
					{`${getLabel('506345','未出勤') } ${absenceDay} ${getLabel('503882','天') }`}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/components/absenceDetail/AbsenceBrief.js